import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./BigNavbar.css";

// BigNavbar component definition
function BigNavbar(props) {
  // Destructure the translation function from useTranslation hook
  const { t } = useTranslation("global");
  const [langState, setLangState] = useState(
    localStorage.getItem("lang") || "en"
  ); // Default to 'en' if no lang in localStorage

  // Function to handle user logout
  const handleLogout = () => {
    localStorage.clear(); // Clear local storage
    window.location.href = "/"; // Redirect to home page
  };

  // Function to handle profile navigation
  const handleProfile = () => {
    if (props.user === "") {
      window.location.href = "/loginuser"; // Redirect to login page if user is not logged in
    } else {
      window.location.href = "/profile"; // Redirect to profile page if user is logged in
    }
  };

  useEffect(() => {
    const handleLanguageChange = () => {
      setLangState(localStorage.getItem("lang") || "en");
    };

    window.addEventListener("storage", handleLanguageChange);

    return () => {
      window.removeEventListener("storage", handleLanguageChange);
    };
  }, []);

  useEffect(() => {
    const lang = localStorage.getItem("lang");
    setLangState(lang || "en");
  }, [langState]);

  return (
    <header className="bignavbar">
      <div className="title-container">
        <a href="/">
          <img
            className="bnv-logo"
            src={"/Assets/logo/Sundari.png"}
            alt="Sundori" // Sundori logo
          />
        </a>
        <a
          href="/"
          className={`bnv-title ${langState === "bn" ? "bangla-font" : ""}`}
        >
          {t("navbar.title")} {/* Translated title */}
        </a>
      </div>
      <nav className="menu-container">
        <div className="link-container">
          <a
            className={`link-show ${langState === "bn" ? "bangla-font" : ""}`}
            href="/"
          >
            {t("navbar.home")} {/* Translated home link */}
          </a>
          <a
            className={langState === "bn" ? "bangla-font" : ""}
            href="identify"
          >
            {t("navbar.identify")}
          </a>
          <a className={langState === "bn" ? "bangla-font" : ""} href="species">
            {t("navbar.species")}
          </a>
          <a
            className={`link-show ${langState === "bn" ? "bangla-font" : ""}`}
            href="about"
          >
            {t("btm-navbar.about")} {/* Translated home link */}
          </a>
          <a
            className={`link-show ${langState === "bn" ? "bangla-font" : ""}`}
            href="faq"
          >
            {t("btm-navbar.faq")}
          </a>
          <a
            className={`link-show ${langState === "bn" ? "bangla-font" : ""}`}
            href="userapi"
          >
            {t("btm-navbar.userapi")}
          </a>
        </div>
        <div className="dropdown">
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {/* Add the hamburger icon */}
            <span className="hamburger-icon">&#9776;</span>{" "}
            {/* Unicode hamburger icon */}
          </button>
          <ul className="dropdown-menu">
            <li className="dropdown-link">
              <a className={langState === "bn" ? "bangla-font" : ""} href="/">
                {t("navbar.home")}
              </a>{" "}
              <a
                className={langState === "bn" ? "bangla-font" : ""}
                href="identify"
              >
                {t("navbar.identify")}
              </a>{" "}
              <a
                className={langState === "bn" ? "bangla-font" : ""}
                href="species"
              >
                {t("navbar.species")}
              </a>{" "}
              <a
                className={`link-show ${
                  langState === "bn" ? "bangla-font" : ""
                }`}
                href="about"
              >
                {t("btm-navbar.about")} {/* Translated home link */}
              </a>
              <a className={langState === "bn" ? "bangla-font" : ""} href="faq">
                {t("btm-navbar.faq")}
              </a>
              <a
                className={langState === "bn" ? "bangla-font" : ""}
                href="userapi"
              >
                {t("btm-navbar.userapi")}
              </a>
              <div
                onClick={handleProfile}
                className={`profile-link ${
                  langState === "bn" ? "bangla-font" : ""
                }`}
              >
                {props.user !== "" ? (
                  <div>{props.user}</div>
                ) : (
                  <div>{t("navbar.login")}</div>
                )}
              </div>
            </li>
            <li>
              {props.user !== "" ? (
                <button onClick={handleLogout} className="dropdown-item">
                  Logout
                </button>
              ) : null}
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default BigNavbar; // Export the BigNavbar component
